import { Image } from '@chakra-ui/react';
import { getRelatedCronosEvmChain } from '@cronos-app/sdk';
import lcroSvg from '@public/tokens/lcro.svg';
import { getSDK } from '@ui/utils/getSDK';
import type { StaticImageData } from 'next/image';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getLcroToken: TokenRegister = (desiredNetwork) => {
  const sdk = getSDK(getRelatedCronosEvmChain(desiredNetwork));
  return {
    type: Token.LCRO,
    symbol: 'LCRO',
    addressL1: '',
    addressL2: '',
    addressCronosEvm: sdk.getContractAddress('LiquidCro'),
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => {
      const tokenImage: StaticImageData = lcroSvg;
      return (
        <Image
          src={tokenImage.src}
          boxSize="24px"
          // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
          alt="lcro"
          {...props}
        />
      );
    },
  };
};
